import React from "react";
import classnames from "classnames";
import { faCircle, faDotCircle } from "@fortawesome/free-regular-svg-icons";
import Icon from "components/Icon"; 
import "./radio-input.scss";

function RadioInput(props) {
  const checked = props.selected === props.value;

  return (
    <label
      className={classnames(
        "radio-input",
        { "checked": checked },
        { "with-clarification": !!props.clarification }
      )}>
      <div>
        <Icon
          icon={
            checked ?
              faDotCircle :
              faCircle
          }
        />
        {props.label}
        {
          !!props.clarification &&
            <p>{props.clarification}</p>
        }
      </div>
      <input
        type="radio"
        name={props.name}
        value={props.value}
        onChange={props.onChange}
      />
    </label>
  );
}

export default RadioInput;